import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthShell from '../auth/AuthShell';
import api from '../api';
import Spinner from '../components/Spinner';

export default function UnsubscribePage() {
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const preview = params.get('preview') === 'true';
    const [document, setDocument] = useState(null);
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        if (preview) return;
        let active = true;
        setDocument(null); setError('');
        api.get('/api/auth/unsubscribe', { params: { token } })
            .then(({ data }) => { if (active) setDocument(data); })
            .catch(() => { if (active) setError('Ссылка отписки недействительна. Используйте ссылку из последнего письма.'); });
        return () => { active = false; };
    }, [token, preview]);
    const revoke = async () => {
        if (busy) return;
        setBusy(true); setError('');
        try {
            await api.get('/api/auth/csrf');
            const { data } = await api.post('/api/auth/unsubscribe', { token });
            setDocument(data);
        } catch (failure) {
            setError(failure.response?.data?.detail || 'Не удалось отписаться. Попробуйте ещё раз.');
        } finally { setBusy(false); }
    };
    return <AuthShell title="Отписка от рассылки">
        {preview ? <p className="auth-description">Это пример ссылки отписки. В рассылке каждый получатель получит персональную ссылку для отзыва своего согласия.</p>
            : document ? <div className="flex flex-col gap-4">
                <p className="auth-description">{document.title} · версия {document.version}</p>
                {document.status === 'revoked' ? <p role="status" className="auth-description">Согласие отозвано. Рассылки по этому согласию больше не будут отправляться.</p>
                    : document.status === 'superseded' ? <p className="auth-description">После этого письма согласие было принято заново. Для отписки используйте ссылку из нового письма.</p>
                        : <><p className="auth-description">Отозвать это согласие и прекратить получение рассылок по нему?</p>
                            <button className="auth-primary" type="button" disabled={busy} onClick={revoke}>{busy ? 'Отписываем…' : 'Отписаться и отозвать согласие'}</button></>}
            </div> : !error && <Spinner />}
        {error && <p role="alert" className="auth-error mt-4">{error}</p>}
    </AuthShell>;
}
